import { useFragment } from 'react-relay';
import { categoryInfoEntryFragment } from './CategoryInfoEntry.relay';
import type { CategoryInfoEntryPropsType } from './types';

const CategoryInfoEntry: React.FC<CategoryInfoEntryPropsType> = (props: CategoryInfoEntryPropsType) => {
  const entry = useFragment(categoryInfoEntryFragment, props.entry);

  return (
    <p className="flex gap-8 m-0 text-sm">
      <span>{entry.label}</span>
      <span>{entry.value}</span>
    </p>
  );
};

export { CategoryInfoEntry };
